import { getBaseApi } from "../api";

const api = getBaseApi();

export const getNotifications = async (filter?: {
  nextCursor?: string;
  prevCursor?: string;
  limit?: number;
  audience?: 'User' | 'Organisation' | 'Workspace';
}) => {
  const response = await api.get('/notifications', { params: {
    nextCursor: filter?.nextCursor,
    prevCursor: filter?.prevCursor,
    limit: filter?.limit,
    audience: filter?.audience,
  } });
  return response.data;
};

export const markNotificationsAsRead = async (notificationStatusIds: string[]) => {
  const response = await api.post('/notifications/read', { notificationIds: notificationStatusIds });
  return response.data;
};

export const markAllNotificationsAsRead = async () => {
  const response = await api.post('/notifications/read-all');
  return response.data;
};

